var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 10,
    fill: "#FFF7F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 19H35.3333V17.8333C35.3333 17.5239 35.2104 17.2272 34.9916 17.0084C34.7728 16.7896 34.4761 16.6667 34.1667 16.6667C33.8572 16.6667 33.5605 16.7896 33.3417 17.0084C33.1229 17.2272 33 17.5239 33 17.8333V19H31.8333C31.5239 19 31.2272 19.1229 31.0084 19.3417C30.7896 19.5605 30.6667 19.8572 30.6667 20.1667C30.6667 20.4761 30.7896 20.7728 31.0084 20.9916C31.2272 21.2104 31.5239 21.3333 31.8333 21.3333H33V22.5C33 22.8094 33.1229 23.1062 33.3417 23.325C33.5605 23.5438 33.8572 23.6667 34.1667 23.6667C34.4761 23.6667 34.7728 23.5438 34.9916 23.325C35.2104 23.1062 35.3333 22.8094 35.3333 22.5V21.3333H36.5C36.8094 21.3333 37.1062 21.2104 37.325 20.9916C37.5438 20.7728 37.6667 20.4761 37.6667 20.1667C37.6667 19.8572 37.5438 19.5605 37.325 19.3417C37.1062 19.1229 36.8094 19 36.5 19ZM23.6667 24.8333C24.5896 24.8333 25.4919 24.5596 26.2593 24.0469C27.0268 23.5341 27.6249 22.8052 27.9781 21.9525C28.3313 21.0998 28.4237 20.1615 28.2437 19.2562C28.0636 18.351 27.6191 17.5195 26.9665 16.8668C26.3139 16.2142 25.4823 15.7697 24.5771 15.5897C23.6718 15.4096 22.7335 15.502 21.8808 15.8552C21.0281 16.2084 20.2993 16.8066 19.7865 17.574C19.2737 18.3414 19 19.2437 19 20.1667C19 21.4043 19.4917 22.5913 20.3668 23.4665C21.242 24.3417 22.429 24.8333 23.6667 24.8333ZM30.6667 36.5C30.9761 36.5 31.2728 36.3771 31.4916 36.1583C31.7104 35.9395 31.8333 35.6428 31.8333 35.3333C31.8333 33.1674 30.9729 31.0902 29.4414 29.5586C27.9098 28.0271 25.8326 27.1667 23.6667 27.1667C21.5007 27.1667 19.4235 28.0271 17.892 29.5586C16.3604 31.0902 15.5 33.1674 15.5 35.3333C15.5 35.6428 15.6229 35.9395 15.8417 36.1583C16.0605 36.3771 16.3572 36.5 16.6667 36.5",
    fill: "#FC5719"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add-person.e99e92604aa774806e5dbf61e5a04196.svg";
export { ForwardRef as ReactComponent };